import { render, staticRenderFns } from "./Chore.vue?vue&type=template&id=56bf1708&"
import script from "./Chore.vue?vue&type=script&lang=js&"
export * from "./Chore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports